module.exports = __webpack_public_path__ + "img/bill-statisch.d8ffd67d.jpg";